// @core/api/endpoints/tenant/remove_tenant_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/tenant';

/**
 * Remove member from tenant
 * Removes a user from tenant membership, revoking their access to all tenant resources. Requires admin privileges on the tenant.
 */
export async function RemoveTenantMember(
  tenant_id: string,
  user_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/members/:user_id`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
